// English
import enAuth from './en/auth.json';
import enCommon from './en/common.json';
import enErrors from './en/errors.json';
import enProcesses from './en/processes.json';
import enRecording from './en/recording.json';
import enOrganization from './en/organization.json';
import enStaff from './en/staff.json';
import enTasks from './en/tasks.json';
import enSettings from './en/settings.json';
import enOnboarding from './en/onboarding.json';
import enDataTable from './en/dataTable.json';
import enForms from './en/forms.json';
import enSystems from './en/systems.json';
import enNav from './en/nav.json';
import enDashboard from './en/dashboard.json';
import enClient from './en/client.json';
import enAi from './en/ai.json';
import enAdmin from './en/admin.json';
import enMisc from './en/misc.json';
import enRecordingDashboard from './en/recordingDashboard.json';
import enEntitySuggestion from './en/entitySuggestion.json';
import enPartner from './en/partner.json';
import enHubspot from './en/hubspot.json';
import enDataSync from './en/dataSync.json';

// German
import deAuth from './de/auth.json';
import deCommon from './de/common.json';
import deErrors from './de/errors.json';
import deProcesses from './de/processes.json';
import deRecording from './de/recording.json';
import deOrganization from './de/organization.json';
import deStaff from './de/staff.json';
import deTasks from './de/tasks.json';
import deSettings from './de/settings.json';
import deOnboarding from './de/onboarding.json';
import deDataTable from './de/dataTable.json';
import deForms from './de/forms.json';
import deSystems from './de/systems.json';
import deNav from './de/nav.json';
import deDashboard from './de/dashboard.json';
import deClient from './de/client.json';
import deAi from './de/ai.json';
import deAdmin from './de/admin.json';
import deMisc from './de/misc.json';
import deRecordingDashboard from './de/recordingDashboard.json';
import deEntitySuggestion from './de/entitySuggestion.json';
import dePartner from './de/partner.json';
import deHubspot from './de/hubspot.json';
import deDataSync from './de/dataSync.json';

// Hungarian
import huAuth from './hu/auth.json';
import huCommon from './hu/common.json';
import huErrors from './hu/errors.json';
import huProcesses from './hu/processes.json';
import huRecording from './hu/recording.json';
import huOrganization from './hu/organization.json';
import huStaff from './hu/staff.json';
import huTasks from './hu/tasks.json';
import huSettings from './hu/settings.json';
import huOnboarding from './hu/onboarding.json';
import huDataTable from './hu/dataTable.json';
import huForms from './hu/forms.json';
import huSystems from './hu/systems.json';
import huNav from './hu/nav.json';
import huDashboard from './hu/dashboard.json';
import huClient from './hu/client.json';
import huAi from './hu/ai.json';
import huAdmin from './hu/admin.json';
import huMisc from './hu/misc.json';
import huRecordingDashboard from './hu/recordingDashboard.json';
import huEntitySuggestion from './hu/entitySuggestion.json';
import huPartner from './hu/partner.json';
import huHubspot from './hu/hubspot.json';
import huDataSync from './hu/dataSync.json';

// French
import frAuth from './fr/auth.json';
import frCommon from './fr/common.json';
import frErrors from './fr/errors.json';
import frProcesses from './fr/processes.json';
import frRecording from './fr/recording.json';
import frOrganization from './fr/organization.json';
import frStaff from './fr/staff.json';
import frTasks from './fr/tasks.json';
import frSettings from './fr/settings.json';
import frOnboarding from './fr/onboarding.json';
import frDataTable from './fr/dataTable.json';
import frForms from './fr/forms.json';
import frSystems from './fr/systems.json';
import frNav from './fr/nav.json';
import frDashboard from './fr/dashboard.json';
import frClient from './fr/client.json';
import frAi from './fr/ai.json';
import frAdmin from './fr/admin.json';
import frMisc from './fr/misc.json';
import frRecordingDashboard from './fr/recordingDashboard.json';
import frEntitySuggestion from './fr/entitySuggestion.json';
import frPartner from './fr/partner.json';
import frHubspot from './fr/hubspot.json';
import frDataSync from './fr/dataSync.json';

const en = {
  ...enAuth,
  ...enCommon,
  ...enErrors,
  ...enProcesses,
  ...enRecording,
  ...enOrganization,
  ...enStaff,
  ...enTasks,
  ...enSettings,
  ...enOnboarding,
  ...enDataTable,
  ...enForms,
  ...enSystems,
  ...enNav,
  ...enDashboard,
  ...enClient,
  ...enAi,
  ...enAdmin,
  ...enMisc,
  ...enRecordingDashboard,
  ...enEntitySuggestion,
  ...enPartner,
  ...enHubspot,
  ...enDataSync
};

const de = {
  ...deAuth,
  ...deCommon,
  ...deErrors,
  ...deProcesses,
  ...deRecording,
  ...deOrganization,
  ...deStaff,
  ...deTasks,
  ...deSettings,
  ...deOnboarding,
  ...deDataTable,
  ...deForms,
  ...deSystems,
  ...deNav,
  ...deDashboard,
  ...deClient,
  ...deAi,
  ...deAdmin,
  ...deMisc,
  ...deRecordingDashboard,
  ...deEntitySuggestion,
  ...dePartner,
  ...deHubspot,
  ...deDataSync
};

const hu = {
  ...huAuth,
  ...huCommon,
  ...huErrors,
  ...huProcesses,
  ...huRecording,
  ...huOrganization,
  ...huStaff,
  ...huTasks,
  ...huSettings,
  ...huOnboarding,
  ...huDataTable,
  ...huForms,
  ...huSystems,
  ...huNav,
  ...huDashboard,
  ...huClient,
  ...huAi,
  ...huAdmin,
  ...huMisc,
  ...huRecordingDashboard,
  ...huEntitySuggestion,
  ...huPartner,
  ...huHubspot,
  ...huDataSync
};

const fr = {
  ...frAuth,
  ...frCommon,
  ...frErrors,
  ...frProcesses,
  ...frRecording,
  ...frOrganization,
  ...frStaff,
  ...frTasks,
  ...frSettings,
  ...frOnboarding,
  ...frDataTable,
  ...frForms,
  ...frSystems,
  ...frNav,
  ...frDashboard,
  ...frClient,
  ...frAi,
  ...frAdmin,
  ...frMisc,
  ...frRecordingDashboard,
  ...frEntitySuggestion,
  ...frPartner,
  ...frHubspot,
  ...frDataSync
};

export const resources = {
  en: { translation: en },
  de: { translation: de },
  hu: { translation: hu },
  fr: { translation: fr }
};

/**
 * The app's locale codes. Every consumer that enumerates languages (i18next
 * config, excel header parsing) must derive from this single list — a second
 * hand-maintained copy once silently broke FR excel imports.
 */
export const supportedLanguages = Object.keys(resources) as readonly (keyof typeof resources)[];

export const defaultNS = 'translation' as const;
